import styled from "styled-components";
import { motion } from "framer-motion";

export const L_Container = styled(motion.div)`
	grid-column: 1 / -1;
	display: grid;
	grid-template-columns: repeat(auto-fit, 50px);
`;
